import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FollowerListComponent} from './follower-list.component';
import {ReadMoreModule} from '../read-more/read-more.module';

@NgModule({
  declarations: [FollowerListComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReadMoreModule
  ],
  exports: [FollowerListComponent]
})
export class FollowerListModule {
}
